import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetricCard = ({ metric, buildingData }) => {
  const getMetricIcon = (metricType) => {
    const icons = {
      occupancy: 'Users',
      maintenance: 'Wrench',
      satisfaction: 'Star',
      revenue: 'DollarSign'
    };
    return icons?.[metricType] || 'BarChart3';
  };

  const getMetricColor = (value, type) => {
    if (type === 'occupancy' || type === 'satisfaction') {
      if (value >= 90) return 'text-success';
      if (value >= 75) return 'text-warning';
      return 'text-error';
    }
    if (type === 'maintenance') {
      if (value <= 24) return 'text-success';
      if (value <= 48) return 'text-warning';
      return 'text-error';
    }
    return 'text-foreground';
  };

  const formatValue = (value, type) => {
    if (type === 'occupancy' || type === 'satisfaction') return `${value}%`;
    if (type === 'maintenance') return `${value}h`;
    if (type === 'revenue') return `$${value?.toLocaleString()}`;
    return value;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10">
            <Icon name={getMetricIcon(metric?.type)} size={20} className="text-primary" />
          </div>
          <div>
            <h4 className="text-sm md:text-base font-semibold text-foreground">{metric?.label}</h4>
            <p className="caption text-muted-foreground">{metric?.description}</p>
          </div>
        </div>
      </div>
      <div className="space-y-3">
        {buildingData?.map((building, index) => {
          const maxValue = Math.max(...buildingData?.map(b => b?.value));
          const percentage = (building?.value / maxValue) * 100;

          return (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-foreground">{building?.name}</span>
                <span className={`text-sm font-semibold data-text ${getMetricColor(building?.value, metric?.type)}`}>
                  {formatValue(building?.value, metric?.type)}
                </span>
              </div>
              <div className="relative h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="absolute top-0 left-0 h-full bg-primary rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                />
              </div>
              {building?.trend && (
                <div className="flex items-center gap-1">
                  <Icon
                    name={building?.trend > 0 ? 'TrendingUp' : 'TrendingDown'}
                    size={12}
                    className={building?.trend > 0 ? 'text-success' : 'text-error'}
                  />
                  <span className={`caption ${building?.trend > 0 ? 'text-success' : 'text-error'}`}>
                    {Math.abs(building?.trend)}% vs last month
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceMetricCard;